<template>
<span>
    <optic-details></optic-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import OpticDetails from '@/components/moduls/OpticDetails';
import PageFooter from '@/components/PageFooter';
export default {
    name :'optic',
    components:{
        OpticDetails,
        PageFooter
    }

    
};
</script>


